/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHideGrid = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m20.586 22 .707.707 1.414-1.414-20-20-1.414 1.414.707.707V8h4.586l1 1H2v6h6V9.414l1 1V15h4.586l1 1H9v6h6v-5.586l1 1V22zm-2-2H18v-.586zm-7-7H11v-.586zM11 18h2v2h-2zM8 3.781V2H6.219zM12.219 8H15V2H9v2.781zM15 10.781V9h-1.782zM19.218 15H22V9h-6v2.781zM18 13v-2h2v2zm4 3v1.782L20.218 16zm-6-8h6V2h-6z" />
        <path d="M8 22H2v-6h6z" />
      </g>
    </g>
  </Icon>
);
export { SvgHideGrid as HideGrid };
